/** macOS detection for ctrl+wheel (trackpad pinch) speed; false outside a browser. */
export const isMacOs = (): boolean => typeof navigator !== 'undefined' && /mac/i.test(navigator.platform);
